import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/main.css")